import { useState, useEffect, useCallback } from 'react';
import { get } from '@/lib/api';

export function useApi<T>(path: string, deps: unknown[] = []) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await get<T>(path);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch');
    } finally {
      setLoading(false);
    }
  }, [path, ...deps]);

  useEffect(() => { void refetch(); }, [refetch]);

  return { data, loading, error, refetch };
}
